// extracted by mini-css-extract-plugin
export default {"addsuppliermain":"InventoryEntry_addsuppliermain__DPNeO","addsupplierformwrapper":"InventoryEntry_addsupplierformwrapper__UoO3r"};